import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = {
  key: 0,
  class: "spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "empty-block--wrapper"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "estates-list" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "estate" }
const _hoisted_10 = {
  key: 0,
  class: "estate-name"
}
const _hoisted_11 = {
  key: 1,
  class: "estate-info estate-address"
}
const _hoisted_12 = { class: "estate-info" }
const _hoisted_13 = {
  key: 2,
  class: "estate-info"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "additional-block" }
const _hoisted_16 = { class: "controls" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "wrapper-additional-info" }
const _hoisted_19 = { class: "deposit" }
const _hoisted_20 = { class: "card-footer" }
const _hoisted_21 = { class: "lawyer-block" }
const _hoisted_22 = {
  key: 0,
  class: "lawyer-label"
}
const _hoisted_23 = {
  key: 1,
  class: "lawyer-info"
}
const _hoisted_24 = {
  key: 0,
  class: "dot"
}
const _hoisted_25 = {
  key: 1,
  class: "dot lawyerName"
}
const _hoisted_26 = {
  key: 2,
  class: "dot phone"
}
const _hoisted_27 = {
  key: 3,
  class: "dot email"
}
const _hoisted_28 = {
  key: 2,
  class: "lawyer-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "title-main" }, "Projects", -1)),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : ($setup.estates.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "empty-block--icon",
              src: require('@/assets/icons/estate-slim.svg')
            }, null, 8, _hoisted_4),
            _cache[0] || (_cache[0] = _createElementVNode("p", null, "You have no active Estates yet", -1))
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList($setup.estates, (estate) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("img", {
                    class: "estate-img",
                    src: estate.logoUrl
                  }, null, 8, _hoisted_8),
                  _createElementVNode("div", _hoisted_9, [
                    (estate.title)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(estate.title), 1))
                      : _createCommentVNode("", true),
                    (estate.address)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(estate.address), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, _toDisplayString($setup.getFirstLastName($setup.landownerDetails)), 1),
                    ($setup.landownerDetails.phone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($setup.landownerDetails.phone), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("a", {
                      class: "estate-info link",
                      href: `mailto:${$setup.landownerDetails.email}`,
                      target: "_blank"
                    }, _toDisplayString($setup.landownerDetails.email), 9, _hoisted_14)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        class: "button default copy",
                        onClick: ($event: any) => ($setup.copyEstateLink(estate)),
                        type: "button"
                      }, "Copy masterplan link", 8, _hoisted_17),
                      ($setup.canEdit(estate))
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            class: "button default edit",
                            to: { name: 'LandownerProfileEstateUpdate', params: { estateId: estate._id } }
                          }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode("Edit", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, "Initial deposit: " + _toDisplayString(estate.initDeposit > 0 ? $setup.formatStripePrice(estate.initDeposit) : "N/A"), 1),
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "dot" }, null, -1)),
                      _createElementVNode("div", {
                        class: _normalizeClass(["additional-info", { success: estate.isRefundable }])
                      }, _toDisplayString(estate.isRefundable ? "Refundable" : "Not refundable"), 3)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    ($setup.isLawyerIdIsObject(estate.lawyerId))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Trust account:"))
                      : _createCommentVNode("", true),
                    (estate.lawyerId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createTextVNode(_toDisplayString(estate?.lawyerId?.detailsId?.companyName), 1),
                          (estate?.lawyerId?.detailsId?.companyAddress)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                            : _createCommentVNode("", true),
                          _createTextVNode(_toDisplayString(estate?.lawyerId?.detailsId?.companyAddress), 1),
                          ($setup.isLawyerIdIsObject(estate.lawyerId))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                            : _createCommentVNode("", true),
                          _createTextVNode(_toDisplayString($setup.lawyerName(estate)), 1),
                          (estate.lawyerId?.phone)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                            : _createCommentVNode("", true),
                          _createTextVNode(_toDisplayString(estate.lawyerId.phone), 1),
                          (estate.lawyerId?.email)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27))
                            : _createCommentVNode("", true),
                          _createTextVNode(_toDisplayString(estate.lawyerId.email), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_28, "-"))
                  ])
                ])
              ])
            ]))
          }), 256))
  ]))
}